import { Colors, FlexBox, SadFaceIcon, Text } from '@helloself/hello-self-ui';
import React from 'react';

import { Toolbar } from './Toolbar';

export function ErrorProfile({ background }: { background?: { backgroundImage: string; backgroundPosition: string } }) {
    return (
        <FlexBox
            {...background}
            backgroundRepeat="no-repeat"
            backgroundSize="100%"
            width="100%"
            height="100%"
            padding="62px 0px"
            justifyContent="center"
        >
            <FlexBox flexDirection="column" width="920px" gap="8px">
                <Toolbar
                    isOwnProfile={false}
                    setIsEditOpen={() => {
                        return;
                    }}
                />

                <FlexBox gap="24px">
                    <FlexBox
                        margin="24px 0"
                        padding="12px"
                        width="100%"
                        height="100%"
                        borderRadius="6px"
                        backgroundColor={Colors.white}
                        justifyContent="center"
                    >
                        <FlexBox width="50%" flexDirection="column" alignItems="center" padding="40px 0 0 0">
                            <SadFaceIcon width="48px" height="48px" />
                            <Text textColor={Colors.midGrey} fontWeight="600" textSize="xxxlarge" margin="24px 0 0 0">
                                Error fetching profile
                            </Text>
                            <Text textColor={Colors.midGrey} fontWeight="600" textAlign="center" margin="8px 0 0 0">
                                There was a problem fetching the profile.
                                <br />
                                Please try again later or contact tech support.
                            </Text>
                        </FlexBox>
                    </FlexBox>
                </FlexBox>
            </FlexBox>
        </FlexBox>
    );
}
